export const UserPermissionStatus = Object.freeze({
  ACCEPTED: "ACCEPTED",
  ACCEPTED_FOR_RETAILER: "ACCEPTED_FOR_RETAILER",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  PENDING_WITHOUT_USER: "PENDING_WITHOUT_USER"
});
